import { MapPin, Navigation, ExternalLink, Clock, Hash } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { useContact } from "@/lib/contact";
import { useContent } from "@/context/ContentContext";

export const LocationSection = () => {
  const CONTACT = useContact();
  const { content } = useContent();

  return (
    <section id="location" className="relative py-24 sm:py-32 bg-[#F8F9FA]">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading caption="موقع المكتب" title="زورونا في منطقة السيف" />
        <div className="grid lg:grid-cols-5 gap-10 items-stretch">
          <Reveal className="lg:col-span-2 flex flex-col gap-6">
            <div className="rounded-3xl border border-slate-200 bg-[#FFFFFF] p-8 flex-1">
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#C80000]/15 text-brand mb-6">
                <MapPin className="h-6 w-6" />
              </div>
              <p data-testid="location-address-text" className="text-base sm:text-lg leading-loose text-slate-900 font-semibold">
                {CONTACT.addressAr}
              </p>
              <p dir="ltr" className="mt-3 text-xs sm:text-sm text-slate-500 text-left leading-relaxed">
                {CONTACT.addressEn}
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-3">
                <span className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-100 px-4 py-2 text-xs text-slate-600" dir="ltr">
                  <Hash className="h-3.5 w-3.5 text-brand" />
                  {CONTACT.plusCode}
                </span>
                {content?.workingHours && (
                  <span data-testid="location-working-hours" className="inline-flex items-center gap-2 rounded-full border border-[#C80000]/30 bg-[#C80000]/8 px-4 py-2 text-xs text-brand">
                    <Clock className="h-3.5 w-3.5" />
                    {content.workingHours}
                  </span>
                )}
              </div>
              <div className="mt-8 flex flex-wrap gap-3">
                <a
                  href={CONTACT.directionsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="location-directions-button"
                  className="inline-flex items-center gap-2 rounded-full bg-[#C80000] px-6 py-3 text-sm font-bold text-white hover:bg-[#E01010] transition-colors duration-300"
                >
                  <Navigation className="h-4 w-4" />
                  احصل على الاتجاهات
                </a>
                <a
                  href={CONTACT.mapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="office-profile-button"
                  className="inline-flex items-center gap-2 rounded-full border border-slate-200 px-6 py-3 text-sm font-bold text-slate-900 hover:border-[#C80000]/55 hover:text-brand transition-colors duration-300"
                >
                  موقع المكتب
                  <ExternalLink className="h-4 w-4" />
                </a>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.15} className="lg:col-span-3">
            <div className="relative h-full min-h-[360px] overflow-hidden rounded-3xl border border-[#C80000]/30 brand-ring">
              <iframe
                title="خريطة موقع مكتب دليل المسافر للحجوزات — السيف، البحرين"
                data-testid="office-map-iframe"
                src={CONTACT.mapEmbed}
                className="absolute inset-0 h-full w-full"
                style={{ border: 0, filter: "saturate(0.85) contrast(1.05)" }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
